import { RadioGroup, RadioGroupDataInterface } from '@systemeio/ui';
import { mollieChangeProfile } from 'modules/profile/payment-gateways/integrations/mollie/api';
import { useMollieProfiles } from 'modules/profile/payment-gateways/integrations/mollie/hooks';
import { PaymentMollieProfileDataInterface, PaymentMollieProfileInterface } from 'modules/profile/payment-gateways/integrations/mollie/types';
import { PaymentGatewaysInterface } from 'modules/profile/payment-gateways/types/payment-gateways-interface';
import React, { useEffect, useMemo, useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface MollieProfileModalProps {
  mollieAccount: NonNullable<PaymentGatewaysInterface['user']['mollieAccount']>;
  onMollieProfileChange: (data: Omit<PaymentMollieProfileInterface, 'status'>) => Promise<void>;
}
const MollieProfileModal = ({
  mollieAccount,
  onMollieProfileChange
}: MollieProfileModalProps) => {
  const {
    t
  } = useLocoTranslation();
  const [mollieProfileModalOpened, setMollieProfileModalOpened] = useState(false);
  const [mollieProfile, setMollieProfile] = useState<PaymentMollieProfileDataInterface>({
    profileId: undefined
  });
  const {
    data: mollieProfiles
  } = useMollieProfiles(mollieProfileModalOpened);
  const [isFetching, setIsFetching] = useState(false);
  const getRadioGroupData = useMemo(() => (): RadioGroupDataInterface<string>[] | undefined => mollieProfiles?.items.map(el => ({
    id: el.id,
    caption: `${el.name} (${el.status})`
  })), [mollieProfiles?.items]);
  const [radioGroupData, setRadioGroupData] = useState<RadioGroupDataInterface<string>[] | undefined>(getRadioGroupData());
  useEffect(() => {
    if (mollieProfiles) {
      setRadioGroupData(getRadioGroupData());
      const selectedProfile = mollieProfiles.items.find(el_0 => el_0.id === mollieAccount.profileId);
      if (selectedProfile) {
        setMollieProfile({
          profileId: selectedProfile.id
        });
      }
    }
  }, [getRadioGroupData, mollieAccount.profileId, mollieProfiles]);
  const onChangeProfile = async (data: PaymentMollieProfileDataInterface) => {
    try {
      setIsFetching(true);
      await mollieChangeProfile(data);
      const newProfile = mollieProfiles?.items.find(el_1 => el_1.id === data.profileId);
      if (newProfile) {
        await onMollieProfileChange({
          name: newProfile.name,
          id: newProfile.id
        });
      }
      setIsFetching(false);
    } catch (e) {
      setIsFetching(false);
      throw e;
    }
  };
  return <>
      <button className={'primary-link'} onClick={() => setMollieProfileModalOpened(true)}>
        {mollieAccount.profileId ? t('dashboard.settings.payment-gateways.mollie_change_profile') : t('dashboard.settings.payment-gateways.mollie_choose_profile')}
      </button>
      <CreateModal needToast={false} fullCaption={t('dashboard.settings.payment-gateways.changing_mollie_profile')} opened={mollieProfileModalOpened} onClose={() => setMollieProfileModalOpened(false)} defaultValues={mollieProfile} creatable={[{
      field: 'profileId',
      onRender: (value, onChange) => <RadioGroup label={t('dashboard.settings.payment-gateways.mollie_choose_profile')} options={radioGroupData} selected={value} onChange={value_0 => onChange(value_0)} disabled={isFetching} key={'mollie-profile-change'} />
    }]} requiredFields={['profileId']} onCreate={onChangeProfile} />
    </>;
};
export default MollieProfileModal;